import capitalize from 'lodash-es/capitalize'

import { identity } from '../../../utils/common'
import { isSubArchive } from '../../../utils/route'

function isEntityTabSubMenuArchiveItem({ name }) {
  return isSubArchive(name)
}

export function isEntityTabSubMenuSubTabsShown(subMenu) {
  return subMenu == null || subMenu.length > 1
}

export function getEntityTabSubMenuSubTabItems({
  counters,
  getCount = identity,
  qaName,
  subMenu,
  t,
}) {
  return subMenu.map(({ name, title }) => ({
    count: getCount(counters?.[name]),
    qaName: `${qaName}${capitalize(name)}`,
    text: t(title),
    value: name,
  }))
}

export function omitEntityTabSubMenuArchiveItems(subMenu) {
  return subMenu.filter(item => !isEntityTabSubMenuArchiveItem(item))
}
